import { __assign, __rest } from "tslib";
import React from "react";
import VeltCommentDialogComposerActionButton from "./VeltCommentDialogComposerActionButton/VeltCommentDialogComposerActionButton";
import VeltCommentDialogComposerAssignUser from "./VeltCommentDialogComposerAssignUser/VeltCommentDialogComposerAssignUser";
import VeltCommentDialogComposerAttachments from "./VeltCommentDialogComposerAttachments/VeltCommentDialogComposerAttachments";
import VeltCommentDialogComposerInput from "./VeltCommentDialogComposerInput/VeltCommentDialogComposerInput";
import VeltCommentDialogComposerRecordings from "./VeltCommentDialogComposerRecordings/VeltCommentDialogComposerRecordings";
import VeltCommentDialogComposerPrivateBadge from "./VeltCommentDialogComposerPrivateBadge/VeltCommentDialogComposerPrivateBadge";
import VeltCommentDialogComposerAvatar from "./VeltCommentDialogComposerAvatar/VeltCommentDialogComposerAvatar";
;
var VeltCommentDialogComposer = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogComposer.ActionButton = VeltCommentDialogComposerActionButton;
VeltCommentDialogComposer.AssignUser = VeltCommentDialogComposerAssignUser;
VeltCommentDialogComposer.Attachments = VeltCommentDialogComposerAttachments;
VeltCommentDialogComposer.Input = VeltCommentDialogComposerInput;
VeltCommentDialogComposer.Recordings = VeltCommentDialogComposerRecordings;
VeltCommentDialogComposer.PrivateBadge = VeltCommentDialogComposerPrivateBadge;
VeltCommentDialogComposer.Avatar = VeltCommentDialogComposerAvatar;
export default VeltCommentDialogComposer;
